<template>
    <div :class="`DshCascader ycFormItem control-${mode}`">
        <!-- 多选 -->
        <template v-if="useMultiple === true">
            <Cascader
                style="width: 100%;"
                :value="cascaderVal"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请选择${propsObj._name}` : ''"
                :data="renderCascaderData"
                :load-data="loadData"
                :change-on-select="propsObj._changeOnSelect"
                :filterable="false"
                :disabled="!finalCanEdit"
                :clearable="clearable"
                :size="propsObj._size"
                :transfer="true"
                @on-change="createItem"
                @on-visible-change="multipleVisibleChange"
            >
                <dsh-control-define
                    :value="valTags"
                    :canEdit="finalCanEdit"
                    :propsObj="{
                        ...propsObj,
                        _showPlaceholder: canEdit
                    }"
                    @delete="deleteItem"
                ></dsh-control-define>
            </Cascader>
        </template>

        <!-- 单选 -->
        <template v-else>
            <Cascader
                style="width: 100%;"
                :value="value[propsObj._key]"
                :class="{
                    'DshCascader-readonly': $isReadonly(canEdit, propsObj),
                    'DshCascader-disabled': $isDisabled(canEdit, propsObj)
                }"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请选择${propsObj._name}` : ''"
                :data="renderCascaderData"
                :load-data="loadData"
                :change-on-select="propsObj._changeOnSelect"
                :filterable="true"
                :disabled="!finalCanEdit"
                :clearable="clearable"
                :size="propsObj._size"
                :transfer="true"
                @on-change="changeVal"
                @on-visible-change="visibleChange"
            ></Cascader>
        </template>
    </div>
</template>

<script>
    import { regionData } from "../../../datas/index.js";
    import controlMixin from "../controlMixin.js";

    const loop = function (data = [], level, parentCode, filterVals = []) {
        if (data && filterVals.length) {
            data = data.filter(item => filterVals.includes(item._key));
        }
        return data
            ? data.reduce((arr, item) => {
                const newItem = {
                    ...item,
                    value: item._key,
                    label: item.name,
                    codeArr: [ ...(parentCode || []), item._key ]
                };
                if (!level || level > item.level) {
                    newItem.children = loop(item.children, level, newItem.codeArr);
                    newItem.children.length && (newItem.loading = false); // 此代码为了所请求的级出现继续加载的箭头图标
                } else {
                    newItem.children = [];
                }
                arr.push(newItem);

                return arr;
            }, [])
            : [];
    };

    export default {
        name: "DshCascader",
        mixins: [controlMixin],
        props: {},
        data () {
            return {
                cascaderVal: [],

                isVisible: false,
                selectVal: []
            };
        },
        computed: {
            useMultiple () {
                return ["regions", "cascaders"].includes(this.propsObj._type) || this.propsObj._multiple;
            },

            // val () {
            //     return this.value[this.propsObj._key];
            // },
            cascaderData: {
                get () {
                    return loop(
                        ["region", "regions"].includes(this.propsObj._type) ? regionData : this.propsObj._data,
                        this.propsObj._cascaderLevel,
                        undefined,
                        this.propsObj._cascaderFilterVals
                    );
                },
                set () {}
            },
            renderCascaderData () {
                return this.cascaderData.map(item => {
                    return {
                        ...item,
                        children: []
                    };
                });
            },
            valTags () {
                return this.value[this.propsObj._key]
                    ? this.value[this.propsObj._key].map(item => this.$getTreeLinealDatas(item, this.cascaderData, "name").join("/"))
                    : [];
            }
        },
        created () {},
        methods: {
            // 动态加载数据
            loadData (treeItem, cb) {
                let list = this.$getTreeLinealDatas(treeItem.codeArr, this.cascaderData);
                treeItem.children = list[list.length - 1].children.map(item => ({ ...item, children: [] }));

                cb();
            },

            /* 多选使用 */
            // 展开和关闭弹窗时触发
            multipleVisibleChange (bool) {
                this.isVisible = bool;

                if (bool === false) {
                    if (this.selectVal.length) {
                        if (this.value[this.propsObj._key].some(item => JSON.stringify(item) == JSON.stringify(this.selectVal))) {
                            this.$Message.error({
                                content: `"${this.$getTreeLinealDatas(this.selectVal, this.cascaderData, "name").join("/")}"已选择，请勿重复选择！`,
                                duration: 5
                            });
                        } else {
                            this.value[this.propsObj._key] = [...this.value[this.propsObj._key], this.selectVal];
                            this.change();
                        }
                    }

                    this.selectVal = [];
                    this.cascaderVal = [];
                }
            },
            // 添加
            createItem (selectVal, ...params) {
                if (this.isVisible) {
                    this.selectVal = selectVal;
                }
            },
            // 删除
            deleteItem (item, index) {
                this.value[this.propsObj._key].splice(index, 1);
                this.change();
            },

            /* 单选使用 */
            // 展开和关闭弹窗时触发
            visibleChange (bool) {
                this.isVisible = bool;
            },
            changeVal (selectVal, ...params) {
                if (this.isVisible || !selectVal.length) {
                    this.value[this.propsObj._key] = selectVal;
                    this.$emit("change", this.value[this.propsObj._key], ...params);
                }
            }
        },
        watch: {
            "propsObj._cascaderLevel" () {
                this.value[this.propsObj._key] = [];
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshCascader {
        width: 100%;
    }
</style>
<style lang="less">
    .DshCascader {

    }

    .ivu-cascader-transfer {
        max-height: 400px!important;
        .ivu-cascader-menu {
            max-height: 400px;
            height: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshCascader.vue